import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';

import type { GameTypeName } from '../types/Game';
import { isGameOfType } from '../utils';
import getHighestValueGame from '../utils/getHighestValueGame';
import getTopPrizeGame from '../utils/getTopPrizeGame';

import type { PokerSpinAndGoState } from './types';

export const selectors = (slice: Slicer<PokerSpinAndGoState>, createSelector: SelectorCreator) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  games: () => slice((state) => state.games),
  watchGames: () => slice((state) => state.watchGames),
  tickerMessage: () => slice((state) => state.tickerMessage),
  userImage: () =>
    createSelector(
      slice,
      (_: RootState, imageId: number) => imageId,
      ({ watchGames }, imageId) => watchGames.userImageMap?.[imageId] || ''
    ),
  highestValueGame: () =>
    createSelector(
      slice,
      (_: RootState, gameType: GameTypeName) => gameType,
      ({ games }, gameType) =>
        getHighestValueGame(games.filter((game) => isGameOfType(game, gameType)))
    ),
  topPrizeGame: () =>
    createSelector(
      slice,
      (_: RootState, gameType: GameTypeName) => gameType,
      ({ games }, gameType) => getTopPrizeGame(games.filter((game) => isGameOfType(game, gameType)))
    )
});
